import * as mt from './mutation-types';

import { RootState } from '../types';
import { MonitoringState, CropsYieldEvolutionPayload } from './types';
import { ActionContext } from 'vuex';

type MonitoringContext = ActionContext<MonitoringState, RootState>;

export default {
  [mt.CLEANUP]({ commit }: MonitoringContext) {
    commit(mt.CLEANUP);
  },
  [mt.FETCHING_CROP_YIELD_EVOLUTION]({ commit }: MonitoringContext, uuid: string) {
    commit(mt.FETCHING_CROP_YIELD_EVOLUTION, { uuid });
  },
  [mt.FETCH_CROP_YIELD_EVOLUTION]({ commit }: MonitoringContext, payload: CropsYieldEvolutionPayload) {
    commit(mt.FETCH_CROP_YIELD_EVOLUTION, payload);
  },
  [mt.FETCH_CROP_FAILURE]({ commit }: MonitoringContext, uuid: string) {
    commit(mt.FETCH_CROP_FAILURE, { uuid });
  },
};
